import lazyLoad from 'app/shared-components/util/lazyLoad';
const ChooseSignUpPage = lazyLoad(() => import('./ChooseSignUpPage'));
const UserSignUpPage = lazyLoad(() => import('./UserSignUpPage'));
const ProviderSignUpPage = lazyLoad(() => import('./ProviderSignUpPage'));
import authRoles from '../../auth/authRoles';

const SignUpConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'sign-up',
      element: <ChooseSignUpPage />,
    },
    {
      path: 'user-sign-up',
      element: <UserSignUpPage />,
    },
    {
      path: 'provider-sign-up',
      element: <ProviderSignUpPage />,
    },
  ],
};

export default SignUpConfig;
